// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-label{display:inline-flex;padding:0 12px;font-size:12px;font-weight:500;line-height:1.6em;color:#fff;border-radius:4px;background-color:#092433}.s-label:not(:last-child){margin-right:8px}", ""]);
// Exports
module.exports = exports;
